import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Layout from "../../../Components/layout";
import logo from "../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import KsaService from "../../../Utilies/Utilies/KsaService";
import KsaLebaraTerms from "./KsaLebaraTerms";
import "./KsaLebaraSignup.css";
import { notify } from "../../../Components/ToastComponent";
import { signinForm} from "../../../Utilies/gamerClubApi";

const KsaLebaraSignup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isEnriched, setIsEnriched] = useState(false);
  const [phone, setPhone] = useState("");
  const [countryKey] = useState("966");
  const [errMsg, setErrMsg] = useState("");

  const [operatorCode, setOperatorCode] = useState("");
  const [productCatalog, setProductCatalog] = useState("");
  const [productSKU, setProductSKU] = useState("");
  const [subscriptionPlanId, setSubscriptionPlanId] = useState("");

  useEffect(() => {
    getScript();
  }, []);

  const getScript = async () => {
    try {
      const lang = localStorage.getItem("i18nextLng") || "en";
      const res = await KsaService.init(lang);

      if (res.success) {
        KsaService.appendScriptToHead(res?.data?.script);

        const checkTPayInterval = setInterval(() => {
          if (window.TPay) {
            clearInterval(checkTPayInterval);
            setOperatorCode(res?.data?.operatorCode);
            setProductCatalog(res?.data?.productCatalog);
            setProductSKU(res?.data?.productSku);
            setSubscriptionPlanId(res?.data?.subscriptionPlanId);

            const enriched = KsaService.isEnriched();
            setIsEnriched(enriched);

            if (!enriched && res?.data?.operatorCode) {
              KsaService.initOperator(res?.data?.operatorCode);
            }
          }
        }, 100);
      }
    } catch (error) {
      console.error("Error initializing KSA service:", error);
    }
  };

  const ensurePhoneNumberWithCountryCode = (phoneNum, countryCode) => {
    phoneNum = phoneNum.trim();
    const countryCodeStr = countryCode.toString();
    if (!phoneNum.startsWith(countryCodeStr)) {
      return countryCodeStr + phoneNum;
    }
    return phoneNum;
  };

  /** Full Saudi mobile: 966 + 5XXXXXXXX (12 digits total), e.g. 966578286835 */
  const isValidKsaLebaraPhone = (fullPhone) =>
    typeof fullPhone === "string" && /^9665\d{8}$/.test(fullPhone);

  const startSubscription = async () => {
    setIsLoading(true);
    setErrMsg("");

    const fullPhone = ensurePhoneNumberWithCountryCode(phone, countryKey);
    console.log("fullPhone", fullPhone);
    const subscriptionInfo = {
      subscriptionPlanId: Number(subscriptionPlanId),
      productCatalog: productCatalog,
      productSku: productSKU,
      customerAccountNumber: String(Date.now()),
      msisdn: isEnriched ? KsaService.getPhoneNumber() : fullPhone,
      operatorCode: operatorCode,
    };

    try {
      const result = await KsaService.confirmSubscription(subscriptionInfo);

      if (result.status) {
        console.log("Subscription result:", result);
        if (result.refCode) {
          setErrMsg("");
          navigate("/success");
        } else if (result.contract?.operationStatusCode === '0') {
          const subscriptionContractId =
            result.contract?.subscriptionContractId ??
            result.contract?.subscriptionContractID ??
            result.contract?.SubscriptionContractId ??
            result.contract?.id;

          const data = {
            phone: fullPhone,
            subscriptionContractId,
            transactionId: result.contract?.transactionId,
            contract: result.contract,
          };
          localStorage.setItem("verifyData", JSON.stringify(data));
          const lang = localStorage.getItem("i18nextLng") || "en";
          localStorage.setItem("language", lang);
          navigate("/ksa-lebara-verify");
        } else if (
          result.contract?.operationStatusCode === '51' &&
          result.contract?.subscriptionContractId
        ) {
          const lang = localStorage.getItem("i18nextLng");
          if (lang === "ar") {
            setErrMsg("لقد اشتركت بالفعل في هذه الخدمة");
          } else {
            setErrMsg("You are already subscribed to this service.");
          }

          setTimeout(async () => {
            try {
              const formData = {
                phone: fullPhone,
               
              };
              const result = await signinForm(formData);

              if (result.token) {
                localStorage.setItem("user_id", result?.user?.id);
                // store token to local storage
                localStorage.setItem("token", result?.token);
                localStorage.setItem(
                  "userImage",
                  JSON.stringify(result?.user?.avatar)
                );
                setTimeout(() => {
                  navigate("/success", { replace: true });
                }, 2500);
              }
            } catch (err) {
              console.error("Login error:", err);
            }
          }, 3000);
        } else {
          setErrMsg(result.contract?.errorMessage || "Subscription failed");
        }
      } else {
        notify(result.errorMessage || "Subscription failed");
      }
              console.log("Subscription result:", result);

    } catch (err) {
      notify(err.response?.data?.message || "Subscription failed");
      console.log("err", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubscribeClick = () => {
    if (!isEnriched && !phone) {
      setErrMsg(t("Phone Number") + " " + t("is required"));
      return;
    }
    if (!isEnriched) {
      const fullPhone = ensurePhoneNumberWithCountryCode(phone, countryKey);
      if (!isValidKsaLebaraPhone(fullPhone)) {
        setErrMsg(t("ksa_lebara_invalid_phone_format"));
        return;
      }
    }
    startSubscription();
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
    if (errMsg) setErrMsg("");
  };

  return (
    <Layout>
      <img className="servImg mb-4" src={logo} alt="" />

      <div className="ksa-signup-content">
        <div className="text-center my-3 ">
          <span className="mb-0">{t("desc")}</span>
        </div>

        {isEnriched ? (
          <div className="row d-flex justify-content-center mx-0 mt-2 px-4">
            <button
              type="button"
              onClick={handleSubscribeClick}
              className="shadow-none submit-btn w-100 m-auto d-block"
              disabled={isLoading}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                t("subscribe")
              )}
            </button>
          </div>
        ) : (
          <form className="px-3" onSubmit={(e) => e.preventDefault()}>
            <div className="mb-3 form-group d-flex gap-2" style={{direction: "ltr !important"}}>
              <input
                readOnly
                type="text"
                className="form-control w-25 shadow-none text-dark"
                value={countryKey}
              />
              <input
                type="text"
                className={`form-control w-75 ms-2 shadow-none text-dark ${
                  phone ? "is-valid" : ""
                }`}
                placeholder="5XX-XXX-XXX"
                maxLength={12}
                value={phone}
                onChange={handlePhoneChange}
                inputMode="numeric"
              />
            </div>

            {errMsg && (
              <span className="text-danger bg-danger-subtle d-block rounded p-1 mb-2">
                {errMsg}
              </span>
            )}

            <div className="mb-3 form-group text-center">
              <button
                type="button"
                onClick={handleSubscribeClick}
                className="shadow-none submit-btn w-100 m-auto d-block"
                disabled={isLoading}
              >
                {isLoading ? t("Processing") : t("subscribe")}
              </button>
            </div>
          </form>
        )}

        <hr className="" />

        <div className="terms ms-md-4 mt-3">
          <KsaLebaraTerms />
        </div>
      </div>
    </Layout>
  );
};

export default KsaLebaraSignup;
